import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

// Escala 50-950 de un estado, leida de las variables de medivelius-tokens.css.
const scale = (name: string) =>
  Object.fromEntries(
    [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].map((step) => [step, `var(--mv-${name}-${step})`]),
  );

/**
 * Preset de PrimeNG para Medivelius.
 * Los valores salen de medivelius-tokens.css; aqui solo se mapean a los tokens de PrimeNG.
 * Primario = magenta (accion, segun el manual de marca). El azul de estructura
 * (enlaces, encabezados de tabla, navegacion) lo pone medivelius-shell.css.
 * Solo se define el esquema claro: la app arranca en claro (app.component).
 */
export const MediveliusPreset = definePreset(Aura, {
  primitive: {
    /*
     * Estados del manual (medivelius-tokens.css). Aura toma el exito de green,
     * la advertencia de yellow/orange, la informacion de blue/sky y el error
     * de red: se apuntan a las escalas de la marca.
     */
    green: scale('success'),
    yellow: scale('warning'),
    orange: scale('warning'),
    blue: scale('info'),
    sky: scale('info'),
    red: scale('danger'),
    borderRadius: {
      none: '0',
      xs: '2px',
      sm: 'var(--mv-radius-sm)',
      md: 'var(--mv-radius-sm)',
      lg: 'var(--mv-radius-md)',
      xl: 'var(--mv-radius-md)',
    },
  },
  semantic: {
    primary: {
      50: 'var(--mv-magenta-50)',
      100: 'var(--mv-magenta-100)',
      200: 'var(--mv-magenta-200)',
      300: 'var(--mv-magenta-300)',
      400: 'var(--mv-magenta-400)',
      500: 'var(--mv-magenta-500)',
      600: 'var(--mv-magenta-600)',
      700: 'var(--mv-magenta-700)',
      800: 'var(--mv-magenta-800)',
      900: 'var(--mv-magenta-900)',
      950: 'var(--mv-magenta-950)',
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: 'var(--mv-focus-ring)',
      offset: '2px',
    },
    colorScheme: {
      light: {
        surface: {
          0: 'var(--mv-surface)',
          50: 'var(--mv-surface-alt)',
          100: 'var(--mv-surface-sunken)',
          200: 'var(--mv-border)',
          300: '#d4d4d4',
          400: '#a3a3a3',
          500: 'var(--mv-ink-muted)',
          600: 'var(--mv-ink-secondary)',
          700: '#3d3d3d',
          800: 'var(--mv-ink)',
          900: '#1f1f1f',
          950: 'var(--mv-surface-inverse)',
        },
        primary: {
          color: 'var(--mv-brand-magenta)',
          contrastColor: 'var(--mv-on-brand)',
          hoverColor: 'var(--mv-brand-magenta-hover)',
          activeColor: 'var(--mv-brand-magenta-hover)',
        },
        text: {
          color: 'var(--mv-ink)',
          hoverColor: 'var(--mv-ink)',
          mutedColor: 'var(--mv-ink-muted)',
          hoverMutedColor: 'var(--mv-ink-secondary)',
        },
      },
    },
  },
  components: {
    // Botones en pildora (manual, seccion 07).
    button: {
      root: {
        borderRadius: 'var(--mv-radius-pill)',
      },
    },
  },
});
